import React from "react";

import { Diff } from "components";
import NotePhase from "components/tables/notes/notePhase";
import { getFormattedDate, getFullName } from "helpers";
import { DealNote } from "types";

import styles from "./noteDiffList.module.scss";

type NoteDiffListProps = {
	notes?: DealNote[];
	loading: boolean;
	className?: string;
	height?: string;
};

export const NoteDiffList = ({
	notes,
	loading,
	className,
}: NoteDiffListProps) => (
	<div className={className}>
		{notes?.map(note => {
			const lastNoteChange = note?.lastNoteChange;

			return (
				<div className={styles.wrappNotesDesc} key={note.id}>
					<div className={styles.notesHeader}>
						<div className={styles.date}>
							{getFormattedDate({
								date: note?.createdAt,
								format: "DD MMMM YYYY",
							})}
						</div>
						<div className={styles.time}>
							{getFormattedDate({
								date: note?.createdAt,
								format: "h:mm a",
							})}
						</div>
						<span className={styles.author}>
							{typeof note?.author === "string"
								? note?.author
								: getFullName(note?.author)}
						</span>
					</div>
					{note?.category?.displayName && (
						<div className={styles.category}>
							<p>Category: </p>
							<span>{note?.category?.displayName}</span>
						</div>
					)}
					<div className={styles.mainNotes}>
						<div className={styles.noteBlock}>
							<NotePhase note={note} />
							{note.title && (
								<div className={styles.noteTitle}>
									<Diff
										newValue={note.title}
										oldValue={
											lastNoteChange?.oldTitle || ""
										}
									/>
								</div>
							)}
							<span className={styles.desc}>
								<Diff
									newValue={note.note}
									oldValue={lastNoteChange?.oldNote || ""}
								/>
							</span>
						</div>
					</div>
				</div>
			);
		})}
		{notes?.length === 0 && !loading && (
			<div className={styles.noRecordsBlock}>No Records to Display</div>
		)}
	</div>
);
